export const transformToRecipientListPayload = (
  formData: {
    name: string;
    recipient_type: "CONSUMER" | "TECHNICIAN" | "BUSINESS";
    description: string;
    tags: string[];
  },
  utilityId: string
) => {
  return {
    remote_utility_id: utilityId,
    name: formData.name,
    recipient_type: formData.recipient_type,
    description: formData.description,
    tags: formData.tags,
  };
};
